export default __webpack_public_path__ + "static/media/logo--.98ea6ef2.png";